__webpack_require__.p = "https://assets-01.periodica.press/site-assets/";